import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import GPWebPlans from "../../../components/gp-web-plans/gp-web-plans";
import GPWebQuestions from "../../../components/gp-web-questions/gp-web-questions";
import "./gp-web-plans-page.css";
import { Link } from 'react-router'
import { BACK_POST_MESSAGE, SEND_WINDOW_INFO } from '../../../actions';

export class GPWebPlansPage extends Component {
  constructor(props) {
    super();
  }

  plan1Handler = () => {
    console.log("-------plan 1 handler clicked--------");
  };

  plan2Handler = () => {
    this.props.handleAction(BACK_POST_MESSAGE);
  };

  accordionHandler = () => {
    this.props.handleAction(SEND_WINDOW_INFO, {scrollHeight: document.body.scrollHeight, scrollTop: false});
  };

  render() {
    const { t } = this.props;

    return (
      <div className="ad-plans-page xs-flex xs-justify-center xs-items-center">
        <div className="ad-plans-modal xs-py3 xs-col-12">
          <div className="ad-plans-modal__title xs-text-3 xs-py2 xs-text-center">
            {t("GP_EXP_TITLE")}
          </div>

          <GPWebPlans {...this.props} plan1Handler={this.plan1Handler} plan2Handler={this.plan2Handler} />

          <div className="ad-plans-login">
              {t("GP_HAVE_ACCOUNT_YET")}&nbsp;
              <Link
                to={`/gp-web/signin${this.props.location.search}`}
                className="ad-plans-login_cta"
              >
                {t("CREATE_ACCOUNT_LOG_IN")}
              </Link>
          </div>

          <GPWebQuestions {...this.props} onToggle={this.accordionHandler} />
        </div>
      </div>
    );
  }
}

GPWebPlansPage.propTypes = {
  t: PropTypes.func.isRequired,
};

GPWebPlansPage.defaultProps = {};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(GPWebPlansPage));



// WEBPACK FOOTER //
// ./src/containers/pages/gp-web-plans/gp-web-plans-page.js